import React from 'react';
import { Spinner, Modal } from 'hyperdb-utils';
import CustomerForm from '../customer/components/Form';
import api from 'api';

class ModalFormCustomer extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    if (!this.props.for || this.props.for === 'create') this.props.api.customer.initCreateForm();
    else this.props.api.customer.initEditForm(this.props.customerId);
  }
  componentWillUnmount() {
    this.props.api.customer.leaveForm();
  }
  render() {
    if (this.props.hasOwnProperty('show') && !this.props.show) return null;
    const { formLoaded, objectData, loading } = this.props;
    const title = this.props.title || 'Create customer';
    return (
      <Modal title={ title } onClose={ this.props.onClose } onAccept={ this.handleSubmit } loading={ loading }>
        <Spinner show={ loading } />
        { formLoaded ? <CustomerForm api={ this.props.api } objectData={ objectData } /> : null }
      </Modal>
    );
  }
  handleSubmit() {
    const customer = this.props.objectData;
    if (this.customerValid(customer)) {
      const data = { objectData: customer };
      if (this.props.for === 'edit') data.id = customer.id;
      this.props.api.customer.submitCustomer(data)
        .then(() => {
          if (this.props.submitSuccessful) {
            this.props.api.customer.setData({ submitSuccessful: false });
            this.props.onCustomerSaved(this.props.savedObject);
          }
        });
    }
  }
  customerValid(customer) {
    const entity = customer.entity_data;
    if (!entity) return false;
    const address = entity.primary_address;
    if (!address) return false;
    const hasCountry = address.country && address.country.value[1];
    return !!customer.language && !!entity.first_name && !!entity.last_name && !!entity.primary_email && hasCountry;
  }
}

ModalFormCustomer.propTypes = {
  api: React.PropTypes.object,
  show: React.PropTypes.boolean,
  onClose: React.PropTypes.func,
  onCustomerSaved: React.PropTypes.func,
};

export default api.connect(ModalFormCustomer, 'customer');



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/common/ModalFormCustomer.jsx